import { Create, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  tier_name: Yup.string().label("Tier name").required(),
  duration: Yup.number().label("Duration").required(),
  price: Yup.number().label("Price").required(),
});

interface formDataType {
  tier_name: string;
  duration: number;
  price: number;
}

export const TierPriceCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tier_name", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.tier_name}
          helperText={(errors as any)?.tier_name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tier_name"
          name="tier_name"
        />
        <TextField
          {...register("duration", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.symbol}
          helperText={(errors as any)?.symbol?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Duration"
          name="duration"
        />
        <TextField
          {...register("price", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.min_usd_start}
          helperText={(errors as any)?.min_usd_start?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Price"
          name="price"
        />
      </Box>
    </Create>
  );
};
